



























import { Component, Prop, Vue } from "vue-property-decorator";
import CmHeader from "@/components/CmHeader.vue";
import { CMProfile } from "@/models/cm-profile.model";
import { CMPRofileApi } from "@/services/api.service";
(window as any).$ = require("jquery");
(window as any).JQuery = require("jquery");
(window as any).bootstrapJq = require("@/lib/bootstrap-jquery.min.js");
(window as any).menuSlide = require("@/lib/menuSlide.js");

@Component({
    components: {
        CmHeader
    }
})
export default class App extends Vue {
    public canView: boolean = false;
    public hasInvitations: boolean = false;

    public get profile(): CMProfile {
        return this.$store.getters.profile;
    }

    public set profile(profile: CMProfile) {
        this.$store.commit("updateProfile", profile);
    }

    public get imgProfile() {
        return this.profile.photo &&
            this.profile.photo !== "" &&
            this.profile.photo !== "#"
            ? this.profile.photo
            : "/img/default-user.png";
    }

    public get isFromAppMobile(): boolean {
        return this.$store.getters.isFromAppMobile;
    }

    public created() {
        this.$store.commit(
            "setIsFromAppMobile",
            this.$route.query.nc && this.$route.query.nc === "1"
        );
    }

    public async mounted() {
        this._set();
        try {
            const footer = await fetch(
                "https://www.codemotion.com/footer.json"
            ).then(async response => await response.json());
            this.$store.commit("setFooter", footer);
        } catch (error) {
            console.error(error);
        }
        try {
            const invitations = await (<any>this.$cfpApi).getInvitations();
            if (invitations.length) {
                if (this.$route.name !== "papers") this.hasInvitations = true;

                let eventsData;

                try {
                    eventsData = await (<any>this.$eventsApi).eventsList({
                        ids: Array.from(
                            new Set(invitations.map(el => el.event_id))
                        )
                    });
                } catch (error) {
                    console.error(error);
                    return;
                }

                invitations.forEach(el => {
                    const eName = eventsData.data.find(
                        event => event.uuid === el.event_id
                    );
                    el["event_name"] = eName ? eName.name : "";
                });
            }
            this.$store.commit("setInvitations", invitations);
        } catch (error) {
            console.error(error);
        }
    }

    private async _set() {
        try {
            const conf = await CMPRofileApi.getConf();
            this.$store.commit("updateConf", conf);
            this.profile = await CMPRofileApi.getUserProfile();
            const url = new URL(window.location.href);
            if (url.searchParams.has("cmtag")) {
                const rex = new RegExp(
                    "(\\?|&)?cmtag=" + url.searchParams.get("cmtag")
                );
                url.search = url.search.replace(rex, "");
                window.location.replace("" + url);
            } else {
                this.canView = true;
            }
        } catch (e) {
            if (e.name === "UnauthorizedRedirect") {
                const url = new URL(window.location.href);
                let cmtag: any = "MY_PROFILE";
                if (url.searchParams.has("cmtag")) {
                    cmtag = url.searchParams.get("cmtag");
                    const rex = new RegExp(
                        "(\\?|&)?cmtag=" + cmtag
                    );
                    url.search = url.search.replace(rex, "");
                }
                window.location.replace(
                    this.$store.getters.conf.sso_url +
                        "/#/SignIn?hop=" +
                        encodeURIComponent("" + url) +
                        "&cmtag=" +
                        cmtag
                );
            } else {
                console.error(e);
            }
        }
    }
}
